import React, { useEffect, useState } from 'react';

const fmtCOP = v => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(v || 0);

// agrupadas: { [tipo]: [{id, tipo, nombre, valor, precio_adicional, stock}, ...] }
// onChange(seleccion) recibe el array de variaciones elegidas (una por tipo) y el total de precio_adicional
export default function ProductVariantSelector({ agrupadas, onChange }) {
  const tipos = Object.keys(agrupadas || {});
  const [seleccion, setSeleccion] = useState({});

  useEffect(() => {
    // Preseleccionar la primera opcion disponible de cada grupo
    const inicial = {};
    tipos.forEach(tipo => {
      const disponible = agrupadas[tipo].find(v => v.stock > 0) || agrupadas[tipo][0];
      if (disponible) inicial[tipo] = disponible;
    });
    setSeleccion(inicial);
  }, [JSON.stringify(agrupadas)]);

  useEffect(() => {
    const elegidas = Object.values(seleccion);
    const totalAdicional = elegidas.reduce((s, v) => s + (v.precio_adicional || 0), 0);
    onChange?.(elegidas, totalAdicional);
  }, [seleccion]);

  if (!tipos.length) return null;

  return (
    <div style={{ marginBottom: 20 }}>
      {tipos.map(tipo => (
        <div key={tipo} style={{ marginBottom: 14 }}>
          <div style={{ fontWeight: 700, fontSize: 13, color: 'var(--forest)', marginBottom: 8, textTransform: 'capitalize' }}>{tipo}</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {agrupadas[tipo].map(v => {
              const activo = seleccion[tipo]?.id === v.id;
              const agotado = v.stock <= 0;
              return (
                <button key={v.id} disabled={agotado}
                  onClick={() => setSeleccion(s => ({ ...s, [tipo]: v }))}
                  style={{
                    padding: '9px 16px', borderRadius: 'var(--r-md)', fontSize: 13, fontWeight: 700,
                    border: activo ? '2px solid var(--forest)' : '1.5px solid rgba(28,58,30,0.2)',
                    background: agotado ? 'var(--cream-dark)' : activo ? 'rgba(159,190,106,0.15)' : '#fff',
                    color: agotado ? 'var(--ink-faint)' : 'var(--forest)',
                    cursor: agotado ? 'not-allowed' : 'pointer', textDecoration: agotado ? 'line-through' : 'none',
                  }}>
                  {v.valor}{v.precio_adicional > 0 ? ` (+${fmtCOP(v.precio_adicional)})` : ''}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
